export default "__VITE_ASSET__D3b8ND7c__"